var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTurnLeft = function SvgTurnLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.505 12.339a.804.804 0 0 1 0-1.102l4.066-4.32a1.55 1.55 0 0 1 2.68 1.062v1.396h4.823a5.357 5.357 0 0 1 5.359 5.359v3.751c0 1.035-.841 1.876-1.876 1.876h-1.072a1.877 1.877 0 0 1-1.875-1.876v-4.02a.27.27 0 0 0-.268-.267H11.25v1.396a1.55 1.55 0 0 1-2.68 1.062zm5.141 3.115v-2.06c0-.446.359-.804.804-.804h5.895c1.035 0 1.876.84 1.876 1.876v4.019c0 .147.12.268.267.268h1.072c.148 0 .268-.12.268-.268v-3.751a3.75 3.75 0 0 0-3.751-3.752H10.45a.8.8 0 0 1-.804-.803v-2.06l-3.45 3.67 3.45 3.668z"
  })));
};
export default SvgTurnLeft;